import React, { useEffect, useRef } from 'react';
import './resume.css';
import Data from './Data';
import Card from './Card';

const Resume = () => {
  const sectionRef = useRef(null);
  const timelineRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    timelineRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const educationData = Data.filter(val => val.category === "education");
  const experienceData = Data.filter(val => val.category === "experience");

  return (
    <section className='resume section' id='resume' ref={sectionRef}>
      <div className='resume__bg-pattern'></div>
      
      <div className='resume__container container'>
        <div className='resume__header'>
          <span className='resume__badge'>My Journey</span>
          <h2 className='section__title'>
            Professional <span className='gradient-text'>Experience</span>
          </h2>
          <div className='section__underline'></div>
          <p className='resume__tagline'>
            A timeline of my professional growth and achievements
          </p>
        </div>

        <div className='resume__content'>
          <div className='resume__grid'>
            {/* Education Column */}
            <div 
              className='timeline timeline--education'
              ref={el => timelineRefs.current[0] = el}
            >
              <div className='timeline__header'>
                <div className='timeline__header-icon'>
                  <i className='icon-graduation'></i>
                </div>
                <h3 className='timeline__header-title'>Education</h3>
              </div>

              <div className='timeline__items'>
                {educationData.map((val, id) => (
                  <Card 
                    key={id} 
                    icon={val.icon} 
                    title={val.title}
                    year={val.year} 
                    desc={val.desc}
                    type="education"
                    index={id}
                  />
                ))}
              </div>
            </div>

            {/* Experience Column */}
            <div 
              className='timeline timeline--experience'
              ref={el => timelineRefs.current[1] = el}
            >
              <div className='timeline__header'>
                <div className='timeline__header-icon'>
                  <i className='icon-briefcase'></i>
                </div>
                <h3 className='timeline__header-title'>Experience</h3>
              </div>

              <div className='timeline__items'>
                {experienceData.map((val, index) => (
                  <Card 
                    key={index} 
                    icon={val.icon} 
                    title={val.title}
                    year={val.year} 
                    desc={val.desc}
                    type="experience"
                    index={index}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;